import * as React from 'react';

interface IOptionButtonProps {
    disabled: boolean;
    isSelected: boolean;
    selectedText: string;
    unselectedText: string;
    onClick: () => void;
    channelKey: string;
}

export default class OptionButton extends React.PureComponent<IOptionButtonProps> {
    public render() {
        const p = this.props;
        const backgroundColor = () => {
            if (p.channelKey === 'tpl-b2c') {
                return p.isSelected ? '#e01d4f' : '#e6e6e6';
            }
            if (p.channelKey === 'camc-b2c') {
                return p.isSelected ? '#B31F29' : '#ffffff';
            }
            return p.isSelected ? '#82a7c7' : '#4d2973';
        };

        const color = () => {
            if (p.channelKey === 'tpl-b2c') {
                return p.isSelected ? '#e6e6e6' : '#e01d4f';
            }
            if (p.channelKey === 'camc-b2c') {
                return p.isSelected ? '#ffffff' : '#B31F29';
            }
            return p.isSelected ? '#fff' : '#fff';
        };

        return (
            <div
                className="option-btn"
                onClick={p.disabled ? undefined : p.onClick}
                style={{
                    cursor: p.disabled ? 'default' : 'pointer',
                    textAlign: 'center',
                    padding: '10px',
                    backgroundColor: backgroundColor(),
                    color: color(),
                    borderRadius: '5px',
                }}
            >
                <div className="option-content">
                    <span className={p.isSelected ? 'remove' : 'add'}>
                        {p.isSelected ? p.selectedText : p.unselectedText}
                    </span>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/components/OptionButton/index.tsx